export const french = {
  translation: {
    // ================================= titles =================================
    titles: {
      popular_add_ons: 'Popular add-ons',
      top: 'TOP',
      hello: 'Bonjour',
      in_your_cart: 'Votre panier',
      search_result: 'Résultats de recherche pour',
      no_items_found: '0 articles trouvés',
      search_empty: 'Aucun résultat à afficher',
      call_staff: 'Nous avons reçu votre appel',
      sub_total: 'Total',
      total: 'Total',
      order_details: 'Détails de la commande',
      order_history: 'Historique des commandes',
      popup_pay: 'Êtes-vous prêt à payer ?',
      payment_success: 'Nous avons reçu votre demande de paiement',
      order_empty: 'Votre commande est vide',
      pending: 'En attente',
      served: 'Confirmée',
      confirmed: 'Confirmée',
      finish_cooking: 'Préparation terminée',
      cancelled: 'Annulée',
      ready_to_order: 'Prêt à commander?',
      order_success: 'Nous avons reçu votre commande',
      maxQuantityPerOrder: 'Max. quantité/commande',
      topping_type_quantity: 'Min {{min}} - Max {{max}}',
      menu_excludes_vat: 'Ce prix exclut la TVA.',
      rescanQR: 'Scannez le QR code pour commander à nouveau.',
      choose_language_to_start: 'Choisissez votre langue maintenant',
      extraFee: 'Frais supplémentaire',
      discountAmount: 'Réduction',
      customizedService: 'Un service personnalisé pour vous',
      selectOption: 'Veuillez sélectionner une option',
      call_staff_reasons: 'Appeler le personnel',
      choose_payment_method: 'Choisissez votre mode de paiement',
      payment_successfully: 'Paiement réussi',
      payment_failed: 'Paiement échoué',
      how_was_your_experience: 'Comment s’est passée votre expérience ?',
      your_details: 'Vos détails',
      how_many_people: 'Combien de personnes êtes-vous ?',
      please_select_number_of_people:
        '*Veuillez sélectionner le nombre de personnes, y compris les nourrissons.',
      choose_number_of_people:
        "Veuillez sélectionner le nombre de personnes à votre table aujourd'hui :",
      buffet: 'Buffet',
      order_placed: 'Commande passée!',
      order_code: 'Code de commande',
      review_order: 'Écrivez-nous un avis ici aussi',
      popular: 'Populaire',
      hope_you_enjoyed: 'Nous espérons que vous avez aimé.',
      review_success: 'Merci beaucoup !',
      popup_food_error_order:
        'Le plat <span style="font-weight:{{fontWeight}}">{{nameFood}}</span> est en rupture de stock !',
      popup_topping_error_order:
        'La garniture <span style="font-weight:{{fontWeight}}">{{nameTopping}}</span> est en rupture de stock !',
      input_a_name: 'Saisissez un nom',
      input_a_phone: 'Saisir un téléphone',
      why_we_need_it: 'Pourquoi en avons-nous besoin ?',
      discount: 'Réduction',
      // tablet
      search: 'Recherche',
      call_staff_tablet: 'Appeler le personnel',
      bill: 'Facture',
      pay: 'Payer',
      table_number: 'Numéro de tablette :',
      ask_for_bill: "DEMANDER L'ADDITION",
      ask_for_bill_decription:
        "Appuyez sur “DEMANDER L'ADDITION” afin que nous puissions apporter l'addition pour vous.",
      not_yet: 'Pas encore',
      quantity: 'Quantité',
      item_table: 'Article',
      status_table: 'Statut',
      price_table: 'Prix',
      other: 'Autre',
    },
    // ================================= descriptions =================================
    descriptions: {
      reached_end: 'Vous avez atteint la fin',
      cart_empty: 'Votre panier est vide',
      hint_cart_empty: 'Cliquez ici pour voir le menu',
      search_empty: "Veuillez vérifier l'orthographe ou essayer différents mots-clés",
      call_staff: 'Nous serons très bientôt présents à votre table, merci de votre patience',
      popup_pay:
        'Appuyez sur « Demande de paiement » pour que nous puissions apporter la facture à votre table.',
      payment_success: 'Nous serons très bientôt présents à votre table, merci de votre patience',
      restaurant_on_capichi:
        'Si vous souhaitez vivre la même expérience à la maison, retrouvez-nous sur<span style="color:{{colorText}}">Capichi Delivery</span>',
      order_empty: 'Commencez votre commande en ajoutant le(s) plat(s) que vous souhaitez manger',
      orderNotFound: 'Commande introuvable !',
      order_success:
        'Nous servirons votre commande dans les plus brefs délais, merci de votre patience.',
      rescanQR:
        'Nous sommes désolés, votre précédente commande ayant été finalisée, vous devez maintenant scanner à nouveau le QR code pour pouvoir commander dans ce restaurant.',
      order_food_and_drink: 'Commandez de la nourriture et des boissons à tout moment',
      seek_for_help: 'Demandez de l’aide au personnel directement en ligne',
      ask_to_pay: 'Demandez à payer lorsque vous avez fini de manger',
      or_ask_directly: 'ou demandez directement',
      haveVAT: 'La TVA {{vatRate}} % est exclue',
      haveServiceFee: 'Nous facturons des frais de service de {{serviceRate}} %',
      popup_payment_success:
        "Votre paiement en ligne est confirmé. Nous vous remercions de nous avoir choisis aujourd'hui et espérons que vous avez passé un bon moment et une expérience merveilleuse.",
      popup_payment_failed:
        "Le paiement n'a pas abouti en raison d'une anomalie. Veuillez réessayer plus tard ou utiliser un autre mode de paiement.",
      tap_to_save_screen: 'Veuillez montrer cet écran au personnel',
      checkouted_order: `Merci de nous avoir choisis aujourd'hui pour votre repas, nous espérons sincèrement que vous avez apprécié votre moment passé avec nous.
      Nous apprécierions vraiment que vous puissiez partager votre expérience ci-dessous afin que nous puissions développer et améliorer notre restaurant.`,
      review_success:
        'Votre avis a été reçu et nous le prendrons en considération pour nous améliorer. Vous avez été vraiment utile !',
      input_a_name:
        "Vous commandez actuellement à partir d'une table avec différentes commandes, pour vous assurer que nous répartissons correctement les commandes, veuillez saisir un nom simple* pour identifier votre commande.",
      input_a_phone:
        'Nous avons besoin de votre numéro de téléphone afin de pouvoir vous envoyer des messages pour suivre votre commande lorsque vous passez une commande avec succès.',
      min_left: '{{min_left}} minutes disponibles à volonté dans le menu suivant.',
    },
    // ================================= actions ==================================
    actions: {
      call_staff: "Demander l'aide du personnel",
      pay: 'Payer',
      back_to_top: 'Retour en haut',
      order: 'Commande',
      go_back: 'Retourner',
      see_menu: 'Afficher le menu',
      order_now: 'Commandez maintenant',
      clear_all: 'Tout effacer',
      search_again: 'Chercher à nouveau',
      retry: 'Recommencez',
      back_to_menu: 'Retour au menu',
      ask_for_bill: 'Demande de paiement',
      not_yet: 'Pas encore',
      discover: 'Découvrir',
      delete_dish: 'Supprimer',
      noteFood: 'Appuyez pour ajouter une demande personnelle',
      addToCart: 'Ajouter au panier',
      addNote: 'Ajouter des notes',
      confirmOrder: 'Confirmer',
      start_ordering: 'Commencez à commander',
      pay_online: 'Payer en ligne',
      send: 'Envoyer',
      try_again: 'Essayer à nouveau',
      call_staff_for_help: 'Appeler le personnel',
      skip: 'Passer',
      next: 'Suivant',
      done: 'Terminer',
      confirm: 'Confirmer',
      order_from_here: 'Commandez ici',
      tap_to_save_screen: "Appuyez pour enregistrer l'écran",
      see_a_menu: 'Voir un menu',
      update: 'Mise à jour',
      cancel: 'Annuler',
      add: 'Ajouter',
      ok: 'OK',
      see_the_time: "Voir l'heure",
    },
    // ================================= errors =================================
    errors: {
      server_error: "Désolé, le serveur n'est malheureusement pas joignable",
      errorOutOfStock:
        'Désolé, cet article est en rupture de stock, veuillez en commander un autre.',
      errorQuantityPerOrder:
        'Le nombre de plats que vous avez sélectionnés a dépassé la quantité maximale. Veuillez choisir à nouveau.',
      errorQuantityExceeded:
        "Désolé, la quantité demandée pour cet article n'est actuellement pas disponible. Veuillez modifier la quantité pour cet article.",
      somethingWrong: "Une erreur s'est produite. Veuillez réessayer!",
      errorFoodHasChanged:
        'Désolé, ce restaurant vient de mettre à jour de nouvelles informations, veuillez réinitialiser le panier.',
      warningMin: 'Veuillez commander un minimum de {{min}} garniture',
      warningMax: 'Veuillez commander uniquement un maximum de {{max}} garniture',
      notFoundFoodItem:
        'Désolé, le restaurant a temporairement arrêté de servir ce plat. Veuillez réessayer plus tard.',
      errorNotOpenTable: `Votre table n'est pas encore ouverte. Veuillez appeler le personnel pour obtenir de l'aide.`,
      max_comment_review: "Jusqu'à {{max}} caractères",
      payment_method_changed: 'Le mode de paiement a changé.',
      payment_method_changed_desc:
        'Veuillez actualiser la page et choisir à nouveau votre mode de paiement.',
      max_characters: "Jusqu'à {{max}} caractères",
      required_floor: 'Veuillez entrer votre étage',
      required_room: 'Veuillez entrer dans votre chambre.',
      required_full_name: "S'il vous plait entrez votre nom en entier",
      errorOutOfStockNEC: 'En rupture de stock',
      rating_already_existed: 'Désolé. Cette commande a été évaluée',
      // Lỗi liên quan đến voucher
      error: 'Erreur',
      voucher_not_suitable: 'Le code promo ne convient pas. Veuillez réessayer',
      voucher_not_found: "Ce code n'existe pas. Veuillez essayer un autre code.",
      voucher_outside_time_period:
        'Le code promo est invalide ou a expiré. Veuillez essayer un autre code.',
      voucher_just_apply_for_restaurants:
        'Le code promo est uniquement applicable pour : {{restaurants}}',
      voucher_min_order_value:
        'Le code promo est applicable pour les commandes de {{min_order_value}}',
      voucher_has_been_used: 'Le code promo a été utilisé',
      voucher_out_of_quantity: 'Code promo épuisé. Veuillez essayer un autre code.',
      min_max_phone_number:
        'Veuillez saisir un numéro de téléphone entre {{min}} et {{max}} caractères.',
    },
    // ================================= languages =================================
    languages: {},
    // ================================= label =================================
    label: {
      required: 'Requis',
      optional: 'Facultatif',
      my_cart: 'Mon panier',
      items_found: 'Articles trouvés',
      sold_out: 'ÉPUISÉ',
      items: 'article(s)',
      powered_by: 'Alimenté par',
      vat: 'TVA',
      service_fee: 'Frais de service',
      your_order: 'Votre commande',
      or: 'ou',
      payment_methods: {
        international_card: 'Carte de crédit',
        atm: 'ATM',
        qr_code: 'Transfert QR',
        e_wallet: 'E-wallet',
      },
      review_or_comment: 'Laissez-nous un avis ou un commentaire',
      only_letters: 'seules les lettres sont acceptées',
      buffet: 'Buffet',
      min_left: '<strong style="color:{{color}}">{{min_left}}</strong> min left',
      all_you_can_drink: 'À volonté',
    },
    // ================================= placeholder =================================
    placeholder: {
      input_search: 'Rechercher des plats, un menu, des boissons...',
      choose_your_floor: 'Choisissez votre étage',
      choose_your_room: 'Choisissez votre chambre',
      your_full_name: 'Votre nom complet',
      no_results: 'Pas de résultats',
      your_name: 'Votre nom',
      your_phone: 'Votre téléphone',
      enter_voucher_code: 'Entrer le code promo',
    },
    popup_start_buffet: {
      course_menu_has_started: 'Le menu de cours est disponible.',
      time_limit: 'Limite de temps',
      time_value: '{{value}} minutes',
      see_menu: 'Voir le menu',
    },
    popup_add_friend_line: {
      line: 'LINE',
      description:
        'Veuillez nous ajouter comme ami LINE pour utiliser le service de commande mobile.',
      add_friend_btn: 'Ajouter comme ami LINE',
      already_added: 'Déjà ajouté comme ami',
    },
  },
}
